module.exports = __webpack_public_path__ + "img/edge_activites_centre_equestre.9dbb8ffe.svg";